import { useEffect, useState, useCallback, useRef, ReactNode } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from "../hook";
import React, { Suspense } from "react";
import Cookies from 'js-cookie';
import { login, logout, updateIsRequest, updateOrganizationData } from "../slice/authSlice";
import { getRoleMatrix, userInfo } from "../../common/api/authApi";
import { refreshSession } from "../../common/api/apiClient";
import { clearAuthCookies } from "../../common/libs/authCookies";
import useDebounce from "../../common/libs/useDebounce";
import Loader from '../Ui/Loader/Loader';
import { deleteRoleState, saveRoleState } from '../slice/roleMatrix';


interface IRedirectAuthorization {
  children: ReactNode;
}

export const RedirectAuthorization: React.FC<IRedirectAuthorization> = ({ children }) => {
  const [isLoginCheck, setIsLoginCheck] = useState<boolean>(true);
  // const [isRequesting, setIsRequesting] = useState(false);
  const userData = useAppSelector(state => state.auth.userData.iinBin);
  const roleMatrix = useAppSelector(state => state.roleMatrix);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  const isInitialMount = useRef(true);
  const [isLoading, setIsLoading] = useState(true);
  const refresh_token = Cookies.get("refresh_token");
  


  useEffect(() => {
    if (!isLoading) return;
    setIsLoading(true);

    const currentTime = Math.floor(Date.now() / 1000);
    const access_token = Cookies.get("access_token");
    const tokenExpiry = Cookies.get("token_expiry");
    const refresh_token = Cookies.get("refresh_token");

    const forceLogout = () => {
      clearAuthCookies();
      setIsLoginCheck(false);
      dispatch(deleteRoleState());
      dispatch(logout());
      navigate('/authorization');
    };

    const loadUserData = () => {
      if (!userData) {
        userInfo()
          .then(response => {
            dispatch(updateOrganizationData(response));
          })
          .catch(forceLogout);
      }

      if (!roleMatrix.isMatrix) {
        getRoleMatrix()
          .then(response => {
            dispatch(saveRoleState(response.data));
          })
          .catch(forceLogout);
      }
    };

    if (!access_token && !refresh_token) {
      forceLogout();
      return;
    }

    const expiryTime = tokenExpiry ? parseInt(tokenExpiry, 10) : currentTime;
    if (currentTime >= expiryTime - 1200) {
      if (refresh_token) {
        // Данные грузим только после рефреша, иначе они уйдут со старым токеном
        // и интерсептор запустит второй рефреш тем же refresh_token
        refreshSession()
          .then(() => {
            dispatch(login());
            setIsLoginCheck(true);
            loadUserData();
          })
          .catch(forceLogout);
      } else {
        forceLogout();
        return;
      }
    } else {
      dispatch(login());
      setIsLoginCheck(true);
      loadUserData();
    }

    setIsLoading(false);
  }, [navigate, location.pathname, param]);

  if (isLoading || !roleMatrix.isMatrix || !userData) return <Loader/>;


  if (!isLoginCheck || !refresh_token) {
    return <Navigate to="/authorization" />;
  }

  return <>{children}</>; 
};